import { isInstallerNativeApp } from './installerSms';

const getCapacitor = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    return window.Capacitor || null;
};

export const getInstallerSessionPlugin = () => {
    if (!isInstallerNativeApp()) {
        return null;
    }

    const Cap = getCapacitor();
    if (Cap?.Plugins?.InstallerSession) {
        return Cap.Plugins.InstallerSession;
    }
    if (typeof Cap?.registerPlugin === 'function') {
        return Cap.registerPlugin('InstallerSession');
    }
    return null;
};

export const persistInstallerSession = async () => {
    const plugin = getInstallerSessionPlugin();
    if (!plugin) return false;

    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    const lastActivityAt =
        localStorage.getItem('lastActivityAt') ||
        String(Date.now());

    if (!token || !user) return false;

    try {
        await plugin.save({
            token,
            user,
            lastActivityAt
        });
        return true;
    } catch (error) {
        console.warn('persistInstallerSession', error);
        return false;
    }
};

export const clearInstallerSession = async () => {
    const plugin = getInstallerSessionPlugin();
    if (!plugin) return;

    try {
        await plugin.clear();
    } catch (error) {
        console.warn('clearInstallerSession', error);
    }
};

/*
 * Поднимает токен из SharedPreferences в localStorage
 * до проверки ProtectedRoute.
 */
export const hydrateInstallerSession =
    async () => {
        const plugin = getInstallerSessionPlugin();
        if (!plugin) {
            return Boolean(
                localStorage.getItem('token') &&
                    localStorage.getItem('user')
            );
        }

        try {
            const data = await plugin.load();
            if (!data?.hasSession) {
                return Boolean(
                    localStorage.getItem('token') &&
                        localStorage.getItem('user')
                );
            }

            if (data.token) {
                localStorage.setItem('token', data.token);
            }
            if (data.user) {
                localStorage.setItem('user', data.user);
            }
            if (data.lastActivityAt) {
                localStorage.setItem(
                    'lastActivityAt',
                    String(data.lastActivityAt)
                );
            } else if (
                !localStorage.getItem('lastActivityAt')
            ) {
                localStorage.setItem(
                    'lastActivityAt',
                    String(Date.now())
                );
            }

            return true;
        } catch (error) {
            console.warn('hydrateInstallerSession', error);
            return Boolean(
                localStorage.getItem('token') &&
                    localStorage.getItem('user')
            );
        }
    };

export const resolvePortalPath = roleId => {
    const role = Number(roleId);
    if (role === 4) return '/customer-cabinet';
    if (role === 5) return '/installer/work';
    if (role === 6 || role === 8) return '/hr/deals';
    if (role === 7) return '/users';
    return '/dashboard';
};
